export default "__VITE_ASSET__CGFUMa$w__"